var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.e1,
        callback: function($$v) {
          _vm.e1 = $$v
        },
        expression: "e1"
      }
    },
    [
      [
        _c("modalError", { ref: "modalError" }),
        _c("modalAlert", { ref: "modalAlert" }),
        _c(
          "v-stepper-header",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.steps > 1,
                expression: "steps > 1"
              }
            ]
          },
          [
            _vm._l(_vm.steps, function(n) {
              return [
                _c(
                  "v-stepper-step",
                  {
                    key: n + "-step",
                    attrs: { complete: _vm.e1 > n, step: n }
                  },
                  [_vm.votesPerVoter.length > 1 ? _c("span") : _vm._e()]
                ),
                n !== _vm.steps ? _c("v-divider", { key: n }) : _vm._e()
              ]
            })
          ],
          2
        ),
        _c(
          "v-stepper-items",
          [
            _c("v-progress-linear", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.progressBar,
                  expression: "progressBar"
                }
              ],
              attrs: { slot: "progress", color: "blue", indeterminate: "" },
              slot: "progress"
            }),
            _c(
              "v-stepper-content",
              { staticClass: "rmv-padding", attrs: { step: _vm.confirmation } },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c("v-col", { attrs: { cols: "12", sm: "12" } }, [
                      _vm.showVoteInfo
                        ? _c(
                            "span",
                            [
                              _c("br"),
                              _c("v-alert", { attrs: { type: "success" } }, [
                                _vm._v(" Seu voto foi realizado com sucesso. ")
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Eleição: " +
                                    _vm._s(_vm.$store.state.vote.electionName)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Título: " +
                                    _vm._s(_vm.$store.state.vote.identifier)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Nome: " + _vm._s(_vm.$store.state.vote.name)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Data: " +
                                    _vm._s(_vm.$store.state.vote.votedOn)
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _c("br"),
                _c("br")
              ],
              1
            ),
            _vm._l(_vm.steps, function(n) {
              return _c(
                "v-stepper-content",
                {
                  key: n + "-content",
                  staticClass: "rmv-padding",
                  attrs: { step: n }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.candidateRolesCurrent
                                      ? _vm.candidateRolesCurrent.name
                                      : ""
                                  )
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    "no-gutters": "",
                                    align: "center",
                                    justify: "center"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "div-minima",
                                      attrs: { sm: "6" }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            align: "center",
                                            justify: "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "rmv-padding",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c("v-col", {
                                                    staticClass: "rmv-padding",
                                                    attrs: { cols: "12" }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-skeleton-loader",
                                                {
                                                  attrs: {
                                                    loading: _vm.loading,
                                                    type:
                                                      "avatar, image, list-item-two-line",
                                                    height: "100%"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: _vm.showImage,
                                                          expression:
                                                            "showImage"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "custom-selector caption"
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            justify: "center"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-avatar",
                                                            {
                                                              staticClass:
                                                                "mb-2",
                                                              attrs: {
                                                                width: "50%",
                                                                height: "30%",
                                                                tile: ""
                                                              }
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    _vm.picture,
                                                                  "aspect-ratio":
                                                                    "1.0"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            justify: "center"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              staticClass:
                                                                "text-md-center rmv-padding"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.number
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            justify: "center"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              staticClass:
                                                                "rmv-padding"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.nickname
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "div-minima",
                                      attrs: { cols: "6" }
                                    },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          refInFor: true,
                                          attrs: { "lazy-validation": "" }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                align: "center",
                                                justify: "center"
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Digite o número do seu candidato"
                                                )
                                              ])
                                            ]
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                align: "center",
                                                justify: "center"
                                              }
                                            },
                                            _vm._l(
                                              _vm.NumberInformation,
                                              function(item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.index,
                                                    staticClass:
                                                      "div-number-information"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(_vm._s(item))
                                                    ])
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                align: "center",
                                                justify: "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "urna_teclado",
                                                  attrs: { cols: "8" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "teclas" },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "1"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("1")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "2"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("2")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "3"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("3")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "4"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("4")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "5"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("5")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "6"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("6")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "7"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("7")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "8"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("8")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "9"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("9")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            "x-large": "",
                                                            outlined: "",
                                                            disabled:
                                                              _vm.disableKey
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "0"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("0")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                align: "center",
                                                justify: "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "urna_teclado",
                                                  attrs: { cols: "12" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "teclas_acao col-12"
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "mr-1",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "BRANCO"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Branco")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            color: "error"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.urna_fill(
                                                                "Corrige"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Corrige")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          ref: "btnConfirm",
                                                          refInFor: true,
                                                          attrs: {
                                                            color: "green",
                                                            disabled: !_vm.isAllowedToContinue
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.nextStep(
                                                                n
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Confirma")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            })
          ],
          2
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }